import React, { useEffect, useState } from 'react';
import {useFetch} from '@utils'
import { Spin, message, Typography, Button, Tag, List, Tooltip } from 'antd';
import {LarpTable } from '@tables';
import { ItemRecipeWikiCsv } from './cvs';
import ItemWikiModal from './ItemWikiModal';
import {sortByString} from '../../../../utils/functions/Sorters'
const { Text } = Typography;

export default function ItemRecepiesWiki({
    tools
  }) {
     const [doFetch] = useFetch();
     const[isLoading, setIsLoading] = useState(true)
     const [searchValue, setSearchValue] = useState("");
     const [dataSource, setDataSource] = useState([]);
     const [result, setResult] = useState([])
     const [amountShown, setAmountShown] = useState(0);
     const [listSource, setListSource] = useState([]);
     const [isModalVisible, setIsModalVisible] = useState(false);
     const [selectedRecord, setSelectedRecord] = useState(undefined);
     const [allItems, setAllItems] = useState([])

      useEffect(() => {
        if(result.length <= 0) {
          return;
        }
        const newDataSource = result?.filter(_ => {
          return _.item?.name?.toLowerCase().includes(searchValue.toLowerCase())
            || _.tool?.name?.toLowerCase().includes(searchValue.toLowerCase())
            || _.item?.id?.toString() === searchValue.toString()
          })
          
        setDataSource(newDataSource);
        setAmountShown(newDataSource.length)
        setListSource(tableList(newDataSource, onRowClick, allItems))
      }, // eslint-disable-next-line
      [result, searchValue, allItems])

      useEffect(() => {
        refresh();
          }, // eslint-disable-next-line
      [searchValue])

      function refresh()
      {
          const url = `/api/item/GetRecepyWiki`
          doFetch(url)
          .then((response) => onLoaded(response.isSuccess, response.result))
  
          function onLoaded(isSuccess, result) { 
            if(isSuccess) {
              setResult(result);
              setIsLoading(false);
              return;
            }
            setResult([])
            message.error('Could not get item recipes');
            setIsLoading(false);
          }

          const secondUrl = `/api/item/getwiki`
          doFetch(secondUrl)
            .then((response) => onItemsLoaded(response.isSuccess, response.result))
  
          function onItemsLoaded(isSuccess, result) { 
            if(isSuccess) {
              setAllItems(result);
              return;
            }
            setAllItems([])
            message.error('Could not get items');
          }
      }

      if(isLoading)
      {
          return <Spin />
      }

      const filterToolArray = tools.map(_ => {
        return {
          text: _.name,
          value: _.id
        }
      })

      const columns = [
        {
          title: 'Id',
          dataIndex: 'id',
          key: 'id',
          hidden: true
        },
        {
          title: 'Item id',
          key: 'itemId',
          render:(record) => {
            return (<Text>{record.item?.id}</Text>)
          },
          sorter: (a, b) => a.item?.id - b.item?.id,
          sortDirections: ['ascend', 'descend', 'ascend']
        },
        {
          title: 'Name',
          key: 'name',
          render:(record) => {
            return (<Button 
                    type='text' 
                    onClick={() => onRowClick(record.item)}
                   >
                    {record.item?.name}
                    </Button>)
            },
          sorter: (a, b) => sortByString(a.item?.name, b.item?.name),
          sortDirections: ['ascend', 'descend', 'ascend']
        },
        {
            title: 'Tool',
            key: 'tool',
            render: (record) => {
                return (<Text>
                  {record.item?.tool.name}
                </Text>)
              },
            filters: filterToolArray,
            onFilter: (value, record) => {
              return record.item?.tool?.id === value
            },
        },
        {
          title: 'Tool level',
          key: 'toolLevel',
          render:(record) => {
            return (<Text>{record.toolLevel}</Text>)
          },
          sorter: (a, b) => a.toolLevel - b.toolLevel,
          sortDirections: ['ascend', 'descend', 'ascend'],
          filters: [
            {
              text:"1",
              value: 1
            },
            {
              text:"2",
              value: 2
            },
            {
              text:"3",
              value: 3
            },
          ],
          onFilter: (value, record) => {
            return record.toolLevel === value
          },
        },
          {
            title: 'Amount crafted',
            key: 'amountCrafted',
            render:(record) => {
              return (<Text>{record.amountCrafted}</Text>)
            },
            sorter: (a, b) => a.amountCrafted - b.amountCrafted,
            sortDirections: ['ascend', 'descend', 'ascend']
        },
        {
          title: 'Items',
          key: 'items',
          render: (record) => {
              const itemsNeeded = []
              if(record.itemsNeeded !== undefined) {
                  record.itemsNeeded.forEach(itemNeed => {
                      const foundItem = allItems.find(_ => _.id === itemNeed.itemId)
                      itemsNeeded.push({
                        id: foundItem?.id,
                        value:`${itemNeed.amount}x ${foundItem?.name}`
                      })
                  }) 
              }

              const tags = itemsNeeded.map(_ => 
                <Tooltip key={_.id} title={`Item id ${_.id}`}>
                  <Tag>{_.value}</Tag>
                </Tooltip>
              )
              return tags
            },
      },
    ].filter(_ => !_.hidden)

    function onRowClick(record) {

      const foundItem = allItems.find(_ => _.id === record.id)
      if(foundItem) {
        setSelectedRecord(foundItem);
        setIsModalVisible(true);
      }
    }

    function onTableChange(pagination, filters, sorter, extra)
    {
      setAmountShown(extra.currentDataSource.length)
    }

    return (
      <>
        <Text>{amountShown} of {result.length} items shown </Text>
        <LarpTable 
          setSearchValue={setSearchValue}
          refresh={refresh}
          dataSource={dataSource}
          columns={columns}
          onTableChange={onTableChange}
          listSource={listSource}
          csv={ItemRecipeWikiCsv(dataSource, allItems)}
        />

      {isModalVisible && <ItemWikiModal 
          setIsModalVisible={setIsModalVisible}
          isModalVisible={isModalVisible}
          record={selectedRecord}
          tools={tools}
          allItems={allItems}
        />} 
      </>
    )
}

export function tableList(  
    list,   
    onRowClick,
    allItems
  ) {
    return list.map(_ => {

      const itemsNeeded = []
      if(_.itemsNeeded !== undefined) {
          _.itemsNeeded.forEach(itemNeed => {
              const foundItem = allItems.find(_ => _.id === itemNeed.itemId)
              itemsNeeded.push(`${itemNeed.amount}x ${foundItem?.name}`)
          }) 
      }

      const tags = itemsNeeded.map(_ => <Tag>{_}</Tag>)
      return (
              <List.Item
                style={{display:"flex", flexDirection:"column"}}
                onClick={() => onRowClick(_.item)}
              >
  
                <List.Item.Meta
                  style={{width:"100%"}}
                  title={`[${_.amountCrafted}] x [${_.item?.id}] ${_.item?.name}`}
                  description={<>
                        {_.item?.tool?.name && <Tag>{`${_.item?.tool?.name} level ${_.toolLevel}`}</Tag>}
                  </>}
                />
                  {tags}
              </List.Item>
      )
    })
  }